<template>
  <b-modal v-model="showModal" header-bg-variant="light"
           title="Add new dispatcher"
           size="lg"
           no-close-on-backdrop
           @cancel="hide"
           @close="hide"
           :ok-disabled="submitted"
           ok-title="Submit"
           @ok="onSubmit($event)">
    <div class="row">
      <div class="col">
        <b-form-group>
          <label>First name</label>
          <b-input placeholder="First name" v-model="user.firstname"
                   :class="{'is-invalid': $v.user.firstname.$error}"></b-input>
          <b-form-invalid-feedback>Enter first name</b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col">
        <b-form-group>
          <label>Last name</label>
          <b-input placeholder="Last name" v-model="user.lastname"
                   :class="{'is-invalid': $v.user.lastname.$error}"></b-input>
          <b-form-invalid-feedback>Enter last name</b-form-invalid-feedback>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-form-group>
          <label>Email address</label>
          <CInput v-model="user.Email" :addInputClasses="{'is-invalid': $v.user.Email.$error}"
                  placeholder="Email"
                  prepend="@"
                  autocomplete="email"
                  :invalid-feedback="getEmailInvalidMessage"/>
        </b-form-group>
      </div>
      <div class="col">
        <b-form-group>
          <label>Mobile phone</label>
          <div>
            <CInput type="tel" maxlength="14" v-model="user.Phone" @input="acceptNumber"
                    :addInputClasses="{'is-invalid': $v.user.Phone.$error}"
                    placeholder="(123) 345-6789"
                    :invalid-feedback="getPhoneInvalidMessage">
              <template #prepend-content>
                <CIcon name="cil-phone"/>
              </template>
            </CInput>
          </div>
        </b-form-group>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      submitted: false,
      id: null,
      showModal: false,
      user: {
        Phone: ''
      }
    }
  },
  methods: {
    show () {
      this.showModal = true
    },
    hide () {
      this.clear()
      this.showModal = false
    },
    onSubmit (evt) {
      evt.preventDefault()
      this.user.Phone = this.user.Phone.replace(/\D/g, '')
      if (this.$v.user.$invalid) {
        this.$v.$touch()
        return
      }
      this.submitted = true
      this.user.Name = this.user.firstname + ' ' + this.user.lastname
      this.$loading.show()
      const axios = this.axios.post('api/create-dispatcher', this.user)
      axios.then(res => {
        this.submitted = false
        if (res && res.status === 200) {
          this.hide()
          this.$toastr.success('Dispatcher created successfully')
          this.$emit('onSaveDispatcher')
        } else {
          this.$toastr.error(res.data.message)
        }
        this.$loading.hide()
      }).catch((error) => {
        this.submitted = false
        if (error.response && error.response.data.message) {
          this.$toastr.error(error.response.data.message)
        }
        this.$loading.hide()
      })
    },
    acceptNumber (value) {
      const x = value
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

      value = !x[2]
        ? x[1]
        : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
      this.user.Phone = value
    },
    clear: function () {
      this.user = {
        Phone: '',
        firstname: '',
        lastname: '',
        email: ''
      }
      this.$v.$reset()
      this.submitted = false
    }
  },
  computed: {
    getEmailInvalidMessage: function () {
      if (this.user.Email && !this.$v.user.Email.email) {
        return 'Enter a valid email address'
      } else {
        return 'Enter an email'
      }
    },
    getPhoneInvalidMessage: function () {
      if (this.user.Phone && !this.$v.user.Phone.length) {
        return 'Enter a valid phone number'
      }
      return ''
    },
    getPasswordInvalidMessage: function () {
      if (this.user.Password && !this.$v.user.Password.minLength) {
        return 'Password must be minimum 6 characters'
      } else {
        return 'Enter a password'
      }
    }
  },
  validations: {
    user: {
      firstname: {
        required
      },
      lastname: {
        required
      },
      Phone: {
        minLength: minLength(10)
      },
      Email: {
        required, email
      }
    }
  }
}

</script>

<style scoped>
</style>
